var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "landing-page-container" }, [
    _c(
      "section",
      { staticClass: "section" },
      [
        _c("h3", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("controlPanel.landingPage.changeVersion")))
        ]),
        _c("Hint", {
          attrs: {
            hint: _vm.$t("controlPanel.landingPage.autoCleanCacheHint"),
            label: _vm.$t("controlPanel.landingPage.autoCleanCacheLabel")
          }
        }),
        _c(
          "button",
          { staticClass: "app-version-button", on: { click: _vm.update } },
          [
            _vm._v(
              _vm._s(_vm.$t("controlPanel.landingPage.updateVersionButton"))
            )
          ]
        )
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "section" },
      [
        _c("h3", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("controlPanel.landingPage.imageUploadTitle")))
        ]),
        _c("ImageUpload", {
          attrs: {
            title: `${_vm.$t("controlPanel.landingPage.imageUploadTitle")}`,
            hint: `${_vm.$t("controlPanel.landingPage.imageHint")}`,
            label: `${_vm.$t("controlPanel.landingPage.label")}`,
            uploadImageWithClick: _vm.uploadImageWithClick,
            uploadImageWithDrop: _vm.uploadImageWithDrop,
            removeImage: _vm.removeImage,
            apply: _vm.apply,
            allowedFormats: ["image/webp"],
            previewUrl: _vm.previewUrl,
            errors: _vm.errors
          }
        })
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "section" },
      [
        _c("h3", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("controlPanel.landingPage.newsletterSection")))
        ]),
        _c("NewsletterManagement")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }